import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AiOutlineShoppingCart,
  AiOutlinePlus,
  AiOutlineMinus,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  incrementQuantity,
  decrementQuantity,
} from "../redux/features/cartSlice";

const ProductCard = ({ id, title, image, weight }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [cartCount, setCartCount] = useState(0);

  // Get the item from Redux store
  const cartItem = useSelector((state) =>
    state.cart.cartItems.find((item) => item.id === id)
  );

  // console.log('cartItem',cartItem);

  // Handle Add to Cart
  const handleAddToCart = (e) => {
    e.stopPropagation();
    setCartCount(1); // Add item and start with 1 quantity
  };

  // Increase item count
  const incrementCount = (e) => {
    e.stopPropagation();
    setCartCount(cartCount + 1);
  };

  // Decrease item count or remove if 0
  const decrementCount = (e) => {
    e.stopPropagation();
    if (cartCount > 1) {
      setCartCount(cartCount - 1);
    } else {
      setCartCount(0); // Remove from cart
    }
  };

  const navigateToProductDetails = () => {
    navigate("productdetails", {
      state: {
        productID: id,
      },
    });
  };

  return (
    <div className="col-span-12 md:col-span-6 lg:col-span-3 bg-white rounded-lg shadow-md  mb-6">
      {/* Product Image */}
      <img
        src={image}
        alt={title}
        className="w-full h-48 object-cover  overflow-hidden transform hover:scale-105 transition duration-300"
      />

      <div className="mt-2 flex items-center  p-4">
        <div onClick={() => navigateToProductDetails()}>
          <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
          {weight && <p className="text-gray-600 text-sm">Weight: {weight}</p>}
        </div>
      </div>

      {/* Product Details */}
      <div className="mt-2 flex items-center justify-between p-2">
        <div>
          {weight && cartItem?.quantity > 0 && (
            <p className="text-gray-600 text-sm">
              Total Weight: <br />
              {(parseFloat(weight) * (cartItem?.quantity || 0)).toFixed(3)} gm
            </p>
          )}
        </div>
        <div>
          {!cartItem ? (
            // Show Add to Cart if item not added
            <button
              onClick={() => dispatch(addToCart({ id, title, image, weight }))}
              className="bg-[#AD826D]  hover:opacity-75 text-white p-2 rounded-full flex items-center justify-center"
            >
              <AiOutlineShoppingCart size={20} />
            </button>
          ) : (
            // Show Counter if item added
            <div className="flex items-center space-x-1 border rounded-3xl">
              <button
                onClick={() => dispatch(decrementQuantity({ id }))}
                className=" text-dark px-2 py-1 rounded-md"
              >
                −
              </button>
              <span className="text-sm font-bold">{cartItem.quantity}</span>
              <button
                onClick={() => dispatch(incrementQuantity({ id }))}
                className=" text-dark px-2 py-1 rounded-md"
              >
                +
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
